import * as React from 'react';

import { Alert, Button } from 'antd';
import { Icon } from '@eduzz/ui-antd-theme';

import { VERTICAL_URL } from 'settings';

interface IProps {
  show: boolean;
}

const OfferReadjustmentAlert = ({ show }: IProps) => {
  if (!show) {
    return null;
  }

  return (
    <Alert
      type='warning'
      message='Aviso sobre contratos antigos'
      description='Você está alterando o valor de novas assinaturas, onde contratos antigos não serão impactados. Deseja reajustar os antigos também?'
      action={
        <Button type='primary' href={`${VERTICAL_URL}/subscriptions/readjustment`} icon={<Icon.ExternalLink  />}>
          Ir para reajustes
        </Button>
      }
    />
  );
};

export { OfferReadjustmentAlert };
